module.exports = __webpack_public_path__ + "img/demo-uci_pm.ac3c72ad.jpg";